import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { handlePhonePaste } from '@shared/__HACKS'
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormMessage,
} from '@shared/ui/form'
import Input from '@shared/ui/input'
import MaskedInput from '@shared/ui/input-mask'
import Switch from '@shared/ui/switch'
import Wrapper from '@shared/ui/wrapper'

import styles from './styles.module.scss'

export default function UserInfoForm ({ isPickup }: { isPickup: boolean }) {
  const { control, watch, setValue, clearErrors } = useFormContext()
  const { t: o } = useTranslation('order')
  const isOtherPerson = watch('isOtherPerson')

  useEffect(() => {
    if (!isOtherPerson) {
      setValue('nameOther', '')
      setValue('phoneOther', '')
      clearErrors([ 'nameOther', 'phoneOther' ])
    }
  }, [ isOtherPerson, setValue, clearErrors ])

  return (
    <Wrapper className={styles.root__wrapper}>
      <h3 className={styles.root__title}>{o('form.your-data')}</h3>
      <div className={styles.root}>
        <div className={styles.form}>
          {
            <div className={styles.form__grid}>
              {[
                { name: 'name', placeholder: o('form.name') },
                { name: 'phone', placeholder: o('form.phone') },
              ].map(({ name, placeholder }) => (
                <FormField
                  key={name}
                  control={control}
                  name={name}
                  render={({ field }) => (
                    <FormItem className={styles.form__apartment}>
                      <FormControl>
                        <Input {...field} placeholder={placeholder} disabled />
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />
              ))}
            </div>
          }

          {!isPickup && (
            <>
              <FormField
                control={control}
                name="isOtherPerson"
                render={({ field }) => (
                  <FormItem className={styles.form__switch}>
                    <FormDescription>{o('form.is-other')}</FormDescription>
                    <FormControl>
                      <Switch
                        onChange={field.onChange}
                        checked={!!field.value}
                      />
                    </FormControl>
                  </FormItem>
                )}
              />
              {isOtherPerson && (
                <div className={styles.form__grid}>
                  {[
                    { name: 'nameOther', placeholder: o('form.nameOther') },
                    {
                      name: 'phoneOther',
                      placeholder: o('form.phoneOther'),
                      isPhone: true,
                    },
                  ].map(({ name, placeholder, isPhone = false }) => (
                    <FormField
                      key={name}
                      control={control}
                      name={name}
                      render={({ field }) => (
                        <FormItem className={styles.form__apartment}>
                          <FormControl>
                            {isPhone ? (
                              <MaskedInput
                                {...field}
                                mask="+7 (___) ___-__-__"
                                placeholder="+7 000 000 00 00"
                                inputMode="numeric"
                                value={
                                  typeof field.value === 'string'
                                    ? field.value
                                    : ''
                                }
                                onPaste={handlePhonePaste}
                              />
                            ) : (
                              <Input
                                {...field}
                                placeholder={placeholder}
                                disabled={!isOtherPerson}
                                value={
                                  typeof field.value === 'string'
                                    ? field.value
                                    : ''
                                }
                              />
                            )}
                          </FormControl>
                          <FormMessage />
                        </FormItem>
                      )}
                    />
                  ))}
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </Wrapper>
  )
}
